module.exports = __webpack_public_path__ + "static/media/switch.7c983132.mp3";